<template>
  <div>
    <view-component title="Biodata Diri FSP" :schema="schema" class="my-2" @edit="onEdit" />
    <base-modal-full ref="modal" generalError title="Update Profil FSP" @save="onSave">
      <formulir-biodata ref="formulir" :initValue="formulir.init" :masters="masters" :detail="formulir.detail" />
    </base-modal-full>
  </div>
</template>

<script>
import ViewComponent from '../base/View';
import FormulirBiodata from '../forms/Biodata';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Biodata',
  components: { ViewComponent, FormulirBiodata },
  props: {
    index: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Object,
      default: () => {},
    },
    biodata: {
      type: Object,
      default: () => {},
    },
    biodataEdit: {
      type: Object,
      default: () => {},
    },
    keyBiodataUpdates: {
      type: Array,
      default: () => [],
    },
    kVervalPsp: {
      type: Number,
      default: 1,
    },
    isEditBiodata: {
      type: Boolean,
      default: false,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formulir: {},
    };
  },
  computed: {
    ...mapState('preferensi', {
      tautan: (state) => (state.layanan && state.layanan.tautan) || [],
    }),

    akunBelajar() {
      const tautan = this.tautan.filter(function(item) {
        return item && +item.k_jenis_sosial === 3;
      });

      return tautan[0] && tautan[0]['email'];
    },

    ptk() {
      return this.$getDeepObj(this.biodata, 'ptk') || {};
    },

    schema() {
      return [
        { title: 'Data Diri', items: this.dasar },
        { title: 'Kontak', items: this.kontak },
        { title: 'Pendidikan terakhir', items: this.pendidikan },
        { title: 'Informasi Pendampingan', items: this.penugasan },
      ];
    },

    dasar() {
      return [
        { label: 'Nama', value: this.ptk.nama || '-' },
        { label: 'NIK', value: this.$getDeepObj(this.biodata, 'psp_profil.nik') || '-' },
        { label: 'Nomor SIMPKB', value: this.biodata.ptk_id || '-' },
        { label: 'Tempat Lahir', value: this.ptk.tmp_lahir || '-' },
        { label: 'Tanggal Lahir', value: this.$localDate(this.ptk.tgl_lahir) || '' },
        { label: 'Usia', value: this.ptk.tgl_lahir ? `${this.$getAge(this.ptk.tgl_lahir)}` : '-' },
        {
          label: 'Alamat (sesuai KTP)',
          value: this.biodata.alamat_ktp || '',
          update: this.keyBiodataUpdates.includes('alamat_ktp'),
        },
        {
          label: 'Provinsi (sesuai KTP)',
          value: this.$getDeepObj(this.biodata, 'm_propinsi_ktp.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_propinsi_ktp'),
        },
        {
          label: 'Kabupaten/Kota (sesuai KTP)',
          value: this.$getDeepObj(this.biodata, 'm_kota_ktp.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_kota_ktp'),
        },
        {
          label: 'Alamat (tempat tinggal sekarang)',
          value: this.biodata.alamat || '',
          update: this.keyBiodataUpdates.includes('alamat'),
        },
        {
          label: 'Provinsi (tempat tinggal sekarang)',
          value: this.$getDeepObj(this.biodata, 'm_propinsi.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_propinsi'),
        },
        {
          label: 'Kabupaten/Kota (Tempat tinggal sekarang)',
          value: this.$getDeepObj(this.biodata, 'm_kota.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_kota'),
        },
        {
          label: 'Kode Pos',
          value: this.biodata.kodepos || '',
          update: this.keyBiodataUpdates.includes('kodepos'),
        },
      ];
    },

    kontak() {
      return [
        {
          label: 'No Telepon (HP)',
          value: this.biodata.no_hp || '',
          update: this.keyBiodataUpdates.includes('no_hp'),
        },
        {
          label: 'No Telepon (HP - WhatsApp)',
          value: this.biodata.no_wa || '',
          update: this.keyBiodataUpdates.includes('no_wa'),
        },
        {
          label: 'No HP prabayar (aktif)',
          value: this.biodata.no_hp_prabayar || '',
          update: this.keyBiodataUpdates.includes('no_hp_prabayar'),
        },
        {
          label: 'Nama pemilik No HP Prabayar (aktif)',
          value: this.biodata.nama_prabayar || '',
          update: this.keyBiodataUpdates.includes('nama_prabayar'),
        },
        {
          label: 'Email (untuk kontak)',
          value: this.biodata.email || '',
          update: this.keyBiodataUpdates.includes('email'),
        },
        {
          label: 'Akun belajar.id dari UPT',
          value: this.biodata.akun_belajar_upt || '-',
          update: this.keyBiodataUpdates.includes('akun_belajar_upt'),
        },
        { label: 'Akun belajar.id yang dimiliki / dari sekolah', value: this.akunBelajar || '-' },
      ];
    },

    pendidikan() {
      return [
        {
          label: 'Pendidikan Terakhir',
          value: this.$getDeepObj(this.biodata, 'm_kualifikasi.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_kualifikasi'),
        },
        {
          label: 'Jurusan',
          value: this.biodata.pendidikan_jurusan || '',
          update: this.keyBiodataUpdates.includes('pendidikan_jurusan'),
        },
        {
          label: 'Bidang Pendidikan Terakhir',
          value: this.$getDeepObj(this.biodata, 'm_profil_opsi_psp_pendidikan_bidang.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_pendidikan_bidang_psp'),
        },
        {
          label: 'Nama Instansi Pendidikan Terakhir',
          value: this.biodata.pendidikan_instansi || '',
          update: this.keyBiodataUpdates.includes('pendidikan_instansi'),
        },
      ];
    },

    penugasan() {
      return [
        {
          label: 'Pengalaman melakukan pendampingan peningkatan mutu pendidikan (pengalaman bersifat akumulasi)',
          value: this.$getDeepObj(this.biodata, 'm_profil_opsi_psp_pendampingan.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_pendampingan_psp'),
        },
        {
          label: 'Unsur Fasilitator',
          value: this.$getDeepObj(this.biodata, 'm_unsur_psp.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_unsur_psp'),
        },
        {
          label: 'Profesi/Pekerjaan saat ini',
          value: this.biodata.profesi || '',
          update: this.keyBiodataUpdates.includes('profesi'),
        },
      ];
    },
  },
  methods: {
    ...mapActions('biodata', ['actions']),

    onEdit() {
      if (!this.isEditBiodata) {
        this.$error('Data tidak bisa diubah karena telah diajukan');
        return;
      }

      if (this.index.tutup) {
        this.$error(this.index.tutup);
        return;
      }

      this.$set(this.formulir, 'init', null);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', Object.assign({}, this.biodata, { akun_belajar: this.akunBelajar }));
      });
    },

    onSave() {
      const values = this.$refs.formulir.getValue();

      let params = {};
      for (const param in values) {
        if (values[param]) {
          params[param] = values[param];
        }
      }

      this.actions({ params, update: this.$isObject(this.edit), action: 'save' })
        .then(() => {
          this.$success('Berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.$emit('reload');
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
